import { createSelector } from 'reselect';

import { selectCartItems } from './selectCartItems';

export const selectUnavailableCartItems = createSelector(
    [selectCartItems],
    (items) => items.filter(item => item.quantity > 0 && !item.isAvailable),
);
